import Vue from 'vue';
import excisePeriodTransformer from '../../transformers/excisePeriod';
import store from '../../store';

const success = ({ data }) => excisePeriodTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const excisePeriod = store.state.productGroup.items.find(p => (
      id.toString() === p.id.toString()
    ));

    if (excisePeriod) {
      return resolve(excisePeriod);
    }

    return Vue.$http.get(`reports/excise_periods/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/showExcisePeriod.js